<mat-card data-at-add-device-modal>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+SRC_COMMISSIONINGV2.ADD_COMPONENT_HEADER' | translate }}</span>
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content overflowShadow>
    <div class="content__body">
      <div class="overview__wrapper">
        <span class="overview__title">{{
          '+SRC_COMMISSIONINGV2.DEVICE_TYPE_SELECT_COMPONENT' | translate
        }}</span>
        <span class="overview__description">{{
          '+SRC_COMMISSIONINGV2.DEVICE_TYPE_SELECT_COMPONENT_DESCRIPTION' | translate
        }}</span>

        <app-banner type="warning" *ngIf="!deviceZigbeeActive">
          {{ '+SRC_COMMISSIONINGV2.ADD_DEVICE_MODAL_LOW_POWER_FUNK_DISABLED' | translate }}
        </app-banner>
      </div>

      <div class="selection__wrapper" #overflowShadowObservedElement>
        <div class="selection__content">
          <div
            gtm="onSelect"
            gtmAction="Change DeviceType"
            gtmCategory="deviteTypeModal"
            class="selection__entry"
            [class.selection__entry--selected]="device === selectedDevice"
            (click)="onDeviceTypeChange(device)"
            *ngFor="let device of devices"
          >
            <img
              class="entry__img"
              src="./assets/img/commissioningv2/device-black-{{ device.icon }}.png"
              alt=""
            />
            <span class="entry__title">{{ device.name | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <div *ngIf="commissioningStore.pairingStatus$ | async as pairingStatus">
      <mat-error
        *ngIf="
          (commissioningService.pairingStatusName$ | async) ===
          ZIGBEE_COORDINATOR_STATUS.TYPE_MISMATCH
        "
      >
        {{ '+SRC_COMMISSIONINGV2.MESSAGE_WRONG_DEVICE_TYPE' | translate }}
      </mat-error>
    </div>
    <button
      data-at-devite-type-modal-confirm-btn
      mat-raised-button
      color="primary"
      (click)="navigateForward()"
      [disabled]="!selectedDevice || !deviceZigbeeActive"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
